import type { ConfigType } from '@app-types/api';

export type HomeBannerData = {
    logo: string;
    logoAlt: string;
    bannerUrlDesktop: string;
    bannerUrlMobile: string;
};

const DEFAULT_BANNER_URL =
    'https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou/summer-edition.webp';
const LOGO_FAI_URL =
    'https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou/Logo_B_you_Fibre_White.svg';
const LOGO_MOBILE_URL =
    'https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/byou/Logo_B_you_Forfait_White.svg';
const LOGO_PACK_URL = 'https://www.bouyguestelecom.fr/assets/media/full/CMS/ECOMMERCE/byou/Logo_Pack_desktop@2x.webp';

interface HomeBannerDataProps {
    config?: ConfigType;
    isMobilePlanFirst: boolean;
    isPack: boolean;
}

export function getHomeBannerData({
    config,
    isMobilePlanFirst,
    isPack,
}: Readonly<HomeBannerDataProps>): HomeBannerData {
    switch (true) {
        case isPack:
            return {
                logo: LOGO_PACK_URL,
                logoAlt: 'B&you Les packs Divertissement',
                bannerUrlDesktop: config?.hero_image_pack?.public_url ?? DEFAULT_BANNER_URL,
                bannerUrlMobile: config?.hero_image_pack_mobile?.public_url ?? DEFAULT_BANNER_URL,
            };
        case isMobilePlanFirst:
            return {
                logo: LOGO_MOBILE_URL,
                logoAlt: 'B&you Les forfait',
                bannerUrlDesktop: config?.hero_image?.public_url ?? DEFAULT_BANNER_URL,
                bannerUrlMobile: config?.hero_image_mobile?.public_url ?? DEFAULT_BANNER_URL,
            };
        default:
            return {
                logo: LOGO_FAI_URL,
                logoAlt: 'B&you pure fibre',
                bannerUrlDesktop: config?.hero_image_fai?.public_url ?? DEFAULT_BANNER_URL,
                bannerUrlMobile: config?.hero_image_fai_mobile?.public_url ?? DEFAULT_BANNER_URL,
            };
    }
}
